<template>
  <div class="page-main" style="padding-bottom:40px">
        <div class="contract-box" v-html="artcCntnt">
        </div>
        <div class="spaceCenter">
            <a-button class="btn-blue-line" style="margin:30px 5px;" @click="goBack()">返回</a-button>
            <a-button type="primary" style="margin:30px 5px;" @click="onConfirm()">签署</a-button>
        </div>
  </div>
</template>

<script>
import {protocolList,signatureSave} from "@/api/lawTxt.js"
export default {
    name:"legaltextsSign",
    data() {
        return {
            artcCntnt:"",
            lawValue:{}
        };
    },
    computed: {},
    methods: {
        borrowedContractList(){
            const row = this.$route.params.data;
            let params;
            params = {
                ...row
            };
            protocolList(params,true)
            .then(res => {
                this.lawValue = res.data;
                this.artcCntnt = res.data.artcCntnt;
            })
            .catch(err => {
                console.log(err);
            })
        },
        goBack(){
            this.$router.go(-1);
        },
        onConfirm(){
            const params = { ...this.lawValue };
            delete params['artcCntnt'];
            signatureSave(params,true)
            .then(res => {
                this.$message.success("法律文本签署成功！");
                this.goBack();
            })
            .catch(err => {
                console.log(err);
            })
        }
    },
    created() {
        this.borrowedContractList();
    },
    mounted() {},
    activated() {},
    watch: {},
};
</script>
<style scoped>
.contract-box{
    width: 86%;
    margin:0 auto;
    border: #e9ebee 1px solid;
    margin-top: 30px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/pages/inquiry/legaltexts-sign.vue